// extracted by mini-css-extract-plugin
export var container = "styles-module--container--be826";
export var description = "styles-module--description--c376e";
export var discountList = "styles-module--discountList--7e0b7";
export var imageContainer = "styles-module--imageContainer--de7f2";
export var prices = "styles-module--prices--156c1";
export var strikethrough = "styles-module--strikethrough--fb95e";
export var textContent = "styles-module--textContent--540d9";